import { DeliveryBanner } from '@carvana/merch-geolocation';
import { useCallback, useContext, useEffect, useRef } from 'react';
import { useUserDeliveryInfo } from '~/contexts/InventoryContext';
import ModalContext from '~/contexts/ModalContext';
import { useTrackEvent } from '~/contexts/SearchAnalyticsContext';
import { useUserLocation } from '~/contexts/UserContext';
import getUserId from '~/utilities/getUserId';

function useSendEvent(shouldSend: boolean, zip: string) {
  const trackEvent = useTrackEvent();

  const zipRef = useRef(zip);
  useEffect(() => {
    zipRef.current = zip;
  }, [zip]);

  useEffect(() => {
    if (!shouldSend) return;

    trackEvent('Delivery Unavailable - Banner Shown', {
      userId: getUserId(),
      zip: zipRef.current
    });
  }, [shouldSend, trackEvent]);
}

export default function DeliveryBannerWrapper() {
  const { setGeolocationModalOpen } = useContext(ModalContext);
  const trackEvent = useTrackEvent();
  const { isDeliveryAllowed } = useUserDeliveryInfo() ?? {};
  const { zip = '' } = useUserLocation();

  const handleClick = useCallback(() => {
    trackEvent('Undeliverable banner - button clicked');
    setGeolocationModalOpen(true);
  }, [setGeolocationModalOpen, trackEvent]);

  const shouldDisplayBanner = isDeliveryAllowed === false && zip !== null;

  useSendEvent(shouldDisplayBanner, String(zip));

  return shouldDisplayBanner ? (
    <div className="mx-auto">
      <DeliveryBanner openCallback={handleClick} zip={zip} />
    </div>
  ) : null;
}
